import { render, staticRenderFns } from "./Create_or_Edit.vue?vue&type=template&id=f206951a&"
import script from "./Create_or_Edit.vue?vue&type=script&lang=js&"
export * from "./Create_or_Edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports